<template>
    <div class="programs">
        <div class="programs__container container">
            <h2 class="programs__title" v-html="title" />
            <p class="programs__text" v-html="text" />
            <div class="programs__list">
                <div class="programs__wrapper">
                    <z-card
                        v-for="card in cardList"
                        :key="card.id"
                        class="programs__card"
                        :href="card.link"
                        theme="secondary"
                        :bg-image="card.image"
                        :content-data="{
                            title: card.title,
                            benefits: card.benefits
                        }"
                    ></z-card>
                </div>
            </div>
        </div>
        <div class="programs__background--top"></div>
        <div class="programs__background--bottom"></div>
    </div>
</template>

<script setup>
import {localize} from '@/utils/i18n'

defineProps({
    title: {
        type: String,
        default: localize({
            ru: 'ИНК – <br>место рождения достижений',
            en: 'INK – <br>where achievements are born',
            cn: '伊尔库茨克石油公司 —<br>成就的发源地<br>自我实现'
        }),
    },
    text: {
        type: String,
        default: localize({
            ru: '<strong>Работа в ИНК</strong> – это стабильность, официальное трудоустройство, самореализация, высокий уровень корпоративной культуры и много других преимуществ.',
            en: '<strong>Working at INK</strong> means stability, official employment, self-fulfillment, high level of&nbsp;corporate culture and many other advantages.',
            cn: '<strong>在伊尔库茨克石油公司工作—</strong> 意味着稳定、正式工作、自我价值实现、优质的企业文化等许多优势。'
        }),
    },
    cardList: {
        type: Array,
        default: () => []
    }
})
</script>

<style lang="scss">
.programs{
    position: relative;
    padding-top: 5.7%;
    background: url(/local/templates/z-template/images/projects/programs-background-20260414.png) no-repeat 100% 0;
    &:before{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 105%;
        background: linear-gradient(115deg, rgba(2, 105, 88, 0.60) 29.18%, rgba(2, 105, 88, 0.00) 57.63%), radial-gradient(87.65% 93.26% at 66.95% 50%, rgba(2, 105, 88, 0.00) 0%, rgba(2, 105, 88, 0.00) 29%, #026958 100%);
        pointer-events: none;
    }
    &:after{
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 105%;
        z-index: -1;
        background: linear-gradient(90deg, #4CB1A1 0%, #036A59 59%);

    }

    @include breakpoint(laptop){
        background-size: contain;
    }

    @include breakpoint(v-tablet){
        padding: 40px 0;
        background: var(--color-primary);
        &:before{
            top: 45px;
            height: 50%;
            background: linear-gradient(180deg, #026958 0%, rgba(2, 105, 88, 0.99) 4.04%, rgba(3, 105, 88, 0.96) 8.09%, rgba(5, 104, 87, 0.92) 12.13%, rgba(8, 103, 86, 0.85) 16.17%, rgba(12, 102, 85, 0.77) 20.22%, rgba(16, 101, 83, 0.67) 24.26%, rgba(20, 100, 82, 0.56) 28.3%, rgba(25, 99, 80, 0.44) 32.35%, rgba(29, 98, 79, 0.33) 36.39%, rgba(33, 97, 77, 0.23) 40.43%, rgba(37, 96, 76, 0.15) 44.48%, rgba(40, 95, 75, 0.08) 48.52%, rgba(42, 94, 74, 0.04) 52.56%, rgba(43, 94, 74, 0.01) 56.61%, rgba(43, 94, 74, 0.00) 60.65%);        }
        &:after{
            top: auto;
            bottom: 0;
            height: 40%;
            background: #036A59;
        }
    }

    &__background{
        &--top{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 308px;
            background: linear-gradient(180deg, rgba(44, 128, 144, 0.00) 0%, #046758 51%, rgba(2, 106, 89, 0.00) 100%);
            transform: translate(0, -50%);
            pointer-events: none;

            @include breakpoint(v-tablet){
                height: 60%;
                background: linear-gradient(180deg, #0D5A55 0%, rgba(11, 110, 95, 0.99) 11.61%, rgba(11, 110, 95, 0.96) 13.33%, rgba(11, 110, 95, 0.92) 20%, rgba(11, 110, 95, 0.85) 26.67%, rgba(11, 110, 95, 0.77) 33.33%, rgba(11, 110, 95, 0.67) 40%, rgba(11, 110, 95, 0.56) 46.67%, rgba(11, 111, 95, 0.44) 53.33%, rgba(11, 111, 95, 0.33) 60%, rgba(11, 111, 95, 0.23) 66.67%, rgba(11, 111, 95, 0.15) 73.33%, rgba(11, 111, 95, 0.08) 80%, rgba(11, 111, 95, 0.04) 86.67%, rgba(11, 111, 95, 0.01) 93.33%, rgba(11, 111, 95, 0.00) 100%);
                transform: unset;
                opacity: 0.3;
            }
        }
        &--bottom{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 208px;
            background: linear-gradient(180deg, rgba(44, 128, 144, 0.00) 0%, #046758 51%, rgba(2, 106, 89, 0.00) 100%);
            transform: translate(0, 20%);
            pointer-events: none;
        }
    }

    &__container{
        position: relative;
        z-index: 1;
    }

    &__title {
        margin-bottom: 38px;
        @include typo-level(2XL);
        color: var(--color-white);

        @include breakpoint(laptop){
            max-width: 574px;
        }

        @include breakpoint(tablet){
            @include margin-level(bottom, M);
            @include typo-level(3XL);

        }

        @include breakpoint(v-tablet){
            max-width: 100%;
        }
    }

    &__text {
        @include margin-level(bottom, XL);
        max-width: 724px;
        font-size: 30px;
        line-height: 150%;
        letter-spacing: 0.3px;
        color: var(--color-white);

        @include breakpoint(laptop){
            max-width: 574px;
            font-size: 24px;
        }

        @include breakpoint(v-tablet){
            max-width: 100%;
            @include typo-level(M);
        }
        @include breakpoint(mobile){
            & strong {
                font-weight: 400;
            }
        }
    }

    &__list{
        @include breakpoint(v-tablet){
            margin-right: -$token-grids-v-tablet-offset;
            margin-left: -$token-grids-v-tablet-offset;
            max-width: calc(100% + $token-grids-v-tablet-offset * 2);
            overflow: scroll;

            &::-webkit-scrollbar{
                display: none;
            }
        }

        @include breakpoint(mobile){
            margin-right: -$token-grids-mobile-offset;
            margin-left: -$token-grids-mobile-offset;
            max-width: calc(100% + $token-grids-mobile-offset * 2);
        }

    }

    &__wrapper{
        display: flex;
        @include gap-level(M);

        @include breakpoint(v-tablet){
            padding-right: $token-grids-v-tablet-offset;
            padding-left: $token-grids-v-tablet-offset;
            width: max-content;
        }
        @include breakpoint(mobile){
            padding-right: $token-grids-mobile-offset;
            padding-left: $token-grids-mobile-offset;
        }
    }
    &__card{
        background-position-y: 100%;
        background-size: 104% 81%;
        object-fit: cover;

        @include breakpoint(v-tablet){
            max-width: 426px;
        }

        @include breakpoint(mobile){
            background-size: 108%;
            max-width: 78.17vw;
        }

        @media sceen and (max-width: 348px){
            background-size: 119%;
        }

        [lang="cn"] & {
            background-size: 107% 84%;
        }

        &-content{
            & ul{
                margin: 0;
            }
        }

        .z-card__content-main{
            @media screen and (min-width: 1024px) and (max-width: 1037px){
                padding-right: 18px;
                padding-left: 18px;
            }
        }
    }
}
</style>
